import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeCapcha, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import { ValidCaptcha } from "../../util/varios";
import axios from "axios";
import ModalConfigUserWeb from "./modalConfUserWeb";

export const SelectTipoUsu = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(true);
  const [deshabilitadoL, setDeshabilitadoL] = useState(false);
  const [titulo, setTitulo] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [contar, setContar] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [juridico, setJuridico] = useState(0);
  const [natural, setNatural] = useState(0);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [tecla, setTecla] = useState();
  const [desde, setDesde] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
  }, []);

  const blanquear = () => {
    setMostrar(false);
    setMostrar1(false);
    setActivate(false);
    setNatural(0);
    setJuridico(0);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const cerrarModalActualizar = () => {
    setMostrar(false);
    props.onHideCancela();
    props.onHideRender();
  };

  const cerrarModal = () => {
    setMostrar(false);
    props.onHideCancela();
  };

  const gestionarUsuarios = (op, id) => (e) => {
    setOperacion(op);

    if (op === 1) {
      setOperacion(1);
      setMostrar(true);
      setNatural(4);
      setJuridico(0);
    } else if (op === 2) {
      setOperacion(1);
      setMostrar(true);
      setJuridico(7);
      setNatural(0);
    }
  };

  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Tipo de Contribuyente.</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <ModalConfigUserWeb
          show={mostrar}
          onHideAcepta={cerrarModalActualizar}
          onHideCancela={cerrarModal}
          operacion={operacion}
          juridic={juridico}
          natur={natural}
        />
        <Dimmer active={activate} />
        <div style={{ height: "auto", overflow: "auto" }}>
          <div className="col-md-12 border-azul rounded">
            <div className="col-md-10 row m-0 py-1">
              <div className="col-md-5">
                <a
                  href="#"
                  class="btn btn-primary btn-lg active"
                  onClick={gestionarUsuarios(1, "")}
                  role="button"
                  aria-pressed="true"
                >
                  NATURAL
                </a>
              </div>
              <div className="col-md-2"></div>
              <div className="col-md-5">
                <a
                  href="#"
                  class="btn btn-primary btn-lg active"
                  onClick={gestionarUsuarios(2, "")}
                  role="button"
                  aria-pressed="true"
                >
                  JURIDICO
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12">
          <div className="col-md-6 ml-auto">
            <button
              ref={btnCancela}
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

//export default CambiarClave;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalSelectTipoUsu.js